module.exports = __webpack_public_path__ + "static/media/aldi3.ed966244.jpg";